<template>
  <div>
    <EmailCaptureDialog
      :show="showCapture"
      @submit="submit"
      :loading="loadingCapture"
      @close="handleDialogClose"/>
    <v-snackbar
      v-model="showMessage"
      location="top"
    >
      E-Mail erfolgreich versendet.
      <template #actions>
        <v-btn
          color="success"
          @click="showMessage = false"
        >
          Schließen
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import EmailCaptureDialog from '@/components/Common/SendAsEmail/EmailCaptureDialog'

export default {
  components: { EmailCaptureDialog },
  props: {
    showCapture: {
      type: Boolean,
      required: true
    },
    loadingCapture: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMessage: false
    }
  },
  methods: {
    async submit ({ email, newsletterConsent }) {
      await this.$emit('submit', {
        email,
        newsletterConsent
      })
      this.showMessage = true
    },
    handleDialogClose () {
      this.$emit('update:showCapture', false)
    }
  }
}
</script>
